module.exports = __webpack_public_path__ + "img/IconaPDF_Color.0a047738.svg";